<div class="section" [ngClass]="{'selected-section': section === selectedSection}">
    <div fxLayout="row"  
            fxLayoutAlign="space-between"
            class="section-header"
            *ngIf="section.header">
        <div [ngClass]="{'section-header-text': !section.isChild, 'section-header-text-child': section.isChild}">
            {{section.header}}
        </div>
        <div fxFlex="50px">
            <button mat-icon-button
                    class="edit-button"
                    *ngIf="(selectedSection !== section && !section.component  && section.allowEdit) && !dialogMode"
                    (click)="editSection()">
                <app-icon-core icon="edit"></app-icon-core>
            </button>
        </div>
    </div>
    <div *ngIf="section.description">
        <p [innerHtml]="section.description"></p>
    </div>
    <ng-content select="[preItemList]"></ng-content>
    <div fxLayout="row" class="section-item">
        <div fxFlex="100px" *ngIf="!subSection" >
            &nbsp;
        </div>
        <div fxFlex>
            <ng-container *ngIf="section.component"
                >
                <div appDynamic [component]="section.component"
                    [props]="section.componentProps"
                    [outputs]="section.componentOutputs"></div>
            </ng-container>
            <ng-container *ngIf="!section.component">
                <div fxLayout="row" *ngFor="let i of section.items" style="align-items: top;">
                    <div [fxFlex]="subSection ? '40' : '250px'" class="item-label">{{i.label}}</div>
                    <div [fxFlex]="subSection ? '60' : '500px'">
                        <app-group-edit-section-item [section]="section"
                            [item]="i"
                            [isSelected]="selectedSection === section || dialogMode"
                        ></app-group-edit-section-item>
                    </div>
                </div>
                <app-edit-view-actions *ngIf="selectedSection === section && !dialogMode"
                        cancelText="Cancel"
                        completeText="Save"
                        [disabled]="!section.form.valid"
                        (completed)="saveSection()"
                        (cancelled)="cancelledSection()"></app-edit-view-actions>
            </ng-container>
        </div>
    </div>
    <ng-content select="[postItemList]"></ng-content>
</div>